import { cn } from '@/lib/utils';
import { healthDotClass, type Health, type Project } from '@/lib/projects';

/** Avatar do projeto: logo se houver, senão a inicial sobre a cor de destaque. */
export function ProjectAvatar({
  project,
  size = 32,
  className,
}: {
  project: Pick<Project, 'name' | 'logo_url' | 'color'>;
  size?: number;
  className?: string;
}) {
  const initial = (project.name ?? '?').trim().charAt(0).toUpperCase() || '?';
  return (
    <div
      className={cn('flex shrink-0 items-center justify-center overflow-hidden rounded-md border bg-muted/40 font-semibold text-foreground', className)}
      style={{ width: size, height: size, backgroundColor: !project.logo_url && project.color ? project.color : undefined, fontSize: size * 0.45 }}
    >
      {project.logo_url
        ? <img src={project.logo_url} alt="" className="size-full object-cover" />
        : <span style={{ color: project.color ? '#fff' : undefined }}>{initial}</span>}
    </div>
  );
}

/** Bolinha do semáforo de saúde da conexão. */
export function HealthDot({ health, className }: { health: Health; className?: string }) {
  return <span className={cn('inline-block size-2.5 shrink-0 rounded-full', healthDotClass(health), className)} />;
}
